<div class="container-fluid">
  <div class="row">
    <div class="col-sm-6 left-side"></div>
    <div class="col-sm-6 right-side d-flex">
      <div class="content">
        <div class="fw-bold title">{{"reset-password.title-expired" | translate }}</div>
        <div class="sub-title pb-4">{{"reset-password.sub-title-expired" | translate}}</div>
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="email"
                   class="login-label-title fw-bold"> {{"reset-password.email" | translate | uppercase}}</label>
            <input type="text" formControlName="email" class="form-control login-form-control" id="email"
                   [ngClass]="{ 'is-invalid': isError }"/>
            <div *ngIf="submitted && f['email'].errors" class="invalid-feedback">
              <div *ngIf="f['email'].errors?.['required']" class="no-match-error-message">
                <img class="no-match-icon" src="/assets/images/icon-alert-triangle.svg" alt="icon-alert-triangle"/>
                <div class="no-match-text">{{ 'reset-password.no-match' | translate }} </div>
              </div>
            </div>
            <div *ngIf="isEmailSend" class="sub-title">
              <div class="no-match-text">{{ 'reset-password.email-send-down' | translate }} </div>
            </div>
            <div class="login-btn-container form-group">
              <button
                class="fw-bold btn btn-login">{{'reset-password.reset' | translate | uppercase}}</button>
              <div [routerLink]="['/login']"
                   class="btn btn-password-forgotten">{{'reset-password.back-to-login' | translate}}</div>
            </div>
          </div>
        </form>
      </div>
      <img class="logo" src="assets/images/banner-explain.png" alt="logo-explain"/>
    </div>
  </div>
</div>


